import { Link } from 'react-router-dom'

import { useTexte } from '../../texte'

/**
 * Chat, Karte — und für den Reisenden die Werkbank.
 *
 * Chat und Karte sind zwei gleichrangige Ansichten derselben Reise: beides ist
 * der Bericht, nur anders erzählt. Die Reiseseite (`/info`) steht daneben und
 * bleibt, wo sie ist — sie ist Verwaltung und keine Ansicht.
 *
 * **„Bearbeiten" ist der dritte Reiter und nur für den Reisenden da.** Die
 * Kartenseite trug lange zwei Rollen auf einmal; bei 66 Highlights stand einem
 * Mitlesenden das Werkzeug im Weg, das er ohnehin nicht anfassen darf. Ob es
 * erscheint, sagt der Server (`may_edit`) — geraten wird das nicht.
 *
 * Unter der Kopfzeile statt darin: auf einem Telefon ist der Kopf schon voll,
 * und ein Umschalter, der sich zwischen Titel und Zurück-Pfeil quetscht, wird
 * mit dem Daumen nicht getroffen.
 */
export function Reiseumschalter({
  tripId,
  aktiv,
  darfBearbeiten = false,
}: {
  tripId: number
  aktiv: 'chat' | 'karte' | 'bearbeiten'
  darfBearbeiten?: boolean
}) {
  const t = useTexte().karte.umschalter
  const feld = (wohin: typeof aktiv) =>
    aktiv === wohin ? 'umschalter__feld umschalter__feld--aktiv' : 'umschalter__feld'

  return (
    <nav className="umschalter" aria-label={t.ansicht}>
      <Link
        className={feld('chat')}
        to={`/t/${tripId}`}
        aria-current={aktiv === 'chat' ? 'page' : undefined}
      >
        {t.chat}
      </Link>
      <Link
        className={feld('karte')}
        to={`/t/${tripId}/karte`}
        aria-current={aktiv === 'karte' ? 'page' : undefined}
      >
        {t.karte}
      </Link>
      {darfBearbeiten && (
        <Link
          className={feld('bearbeiten')}
          to={`/t/${tripId}/karte/bearbeiten`}
          aria-current={aktiv === 'bearbeiten' ? 'page' : undefined}
        >
          {t.bearbeiten}
        </Link>
      )}
    </nav>
  )
}
